import { useState } from 'react';
import PersonalInfo from './PersonalInfo';
import PasswordInfo from './PasswordInfo';
import OtpVerificationForm from './OtpVerification';

const initialValues = {
    firstName: '',
    lastName: '',
    email: '',
    country: '',
    state: '',
    phone: '',
    password: '',
    timezone: '',
    survey: '',
    preferredClass: '',
    smsOptIn: true,
};

export default function SignUp() {
    const [formData, setFormData] = useState(initialValues);
    const [activeTab, setActiveTab] = useState(1);
    const props = { formData, setFormData };

    const urlParams = new URLSearchParams(window.location.search);
    const inviteCode = urlParams.get('invite');

    function extractReferralId(code: string | null) {
        if (!code) return null;
        const matches = code.match(/\d+/);
        if (!matches?.[0]) return null;
        return parseInt(matches[0], 10) - 100;
    }

    const referralId = inviteCode ? extractReferralId(inviteCode) : undefined;

    return (
        <div>
            {activeTab === 1 && (
                <PersonalInfo props={props} setActiveTab={() => setActiveTab(2)} />
            )}
            {activeTab === 2 && (
                <PasswordInfo props={props} setActiveTab={() => setActiveTab(3)} />
            )}
            {activeTab === 3 && (
                <OtpVerificationForm
                    setSubmitForm={() => undefined}
                    formData={formData}
                    referralId={referralId}
                />
            )}
        </div>
    );
}
